var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: _vm.css,
      attrs: { type: "button" },
      on: { click: _vm.question.doClean },
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.question.clearButtonCaption))]),
      _vm._v(" "),
      _vm.question.cssClasses.removeButtonIconId
        ? _c("sv-svg-icon", {
            attrs: {
              iconName: _vm.question.cssClasses.removeButtonIconId,
              size: "auto",
              title: _vm.question.clearButtonCaption,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }